import React from "react";
import logo from "../assets/logosharp.png";
import microsoft from "../assets/Microsoft_Store-Logo.svg";
import itbackground from "../assets/itbackground3.jpg";
import { useMsal } from "@azure/msal-react";

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup().catch((e) => {
      console.error(e);
    });
  };

  return (
    <div className="flex items-center justify-center h-screen w-screen bg-[#132840]">
      <div className="flex flex-row items-center justify-center mt-auto mb-auto ml-auto mr-auto w-5/6 h-5/6 bg-white rounded-xl shadow-2xl">
        <div className="w-2/6 h-full flex flex-col justify-center items-center">
          <img src={logo} className="h-auto w-5/6 mb-5" alt="YouName-IT logo" />
          <button
            className="text-black text-xl w-5/6 h-16 cursor-pointer mx-3 border border-2-black flex flex-row items-center rounded-lg mb-3"
            onClick={handleLogin}
          >
            <img
              src={microsoft}
              alt="microsoft logo"
              className="w-auto h-full"
            />
            Login met Microsoft
          </button>
        </div>
        <div className="hidden md:block md:w-4/6 h-full">
          <img
            src={itbackground}
            alt="it background"
            className="w-full h-full object-cover rounded-r-lg "
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
